module.exports = __webpack_public_path__ + "admin.jpg?5fd1d4e98e6701e94f713044b14ab6be";